import styled from "styled-components";

export const TitleRowTitle = styled.h2`
    font-weight: bold;
    font-size: 21px;
    color: #D5CBFF;
    margin: 0;
    
    @media (max-width: 767px) {
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        width: 100%;
    }
`;